import { render, staticRenderFns } from "./ProductsListInventoryFilters.vue?vue&type=template&id=791832b0"
import script from "./ProductsListInventoryFilters.vue?vue&type=script&lang=js"
export * from "./ProductsListInventoryFilters.vue?vue&type=script&lang=js"
import style0 from "./ProductsListInventoryFilters.vue?vue&type=style&index=0&id=791832b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports